import { ChangeDetectionStrategy, Component, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Incident, IncidentsService } from 'src/app/api/incidents.service';

@Component({
    selector: 'app-edit-incident',
    templateUrl: './edit-incident.component.html',
    styleUrls: ['./edit-incident.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditIncidentComponent implements OnInit {

  incident: WritableSignal<Incident> = signal(this.incidentService.emptyIncident);

  constructor(
    private incidentService: IncidentsService,
    private route: ActivatedRoute, 
    private router: Router
  ) { 

  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const idString = params.get("id")
      if (idString) {
        const id = Number.parseInt(idString)
        this.incidentService.getIncident(id).subscribe(incident => {
          this.incident.set(incident)
        })
      }
    })
  }

  updateIncident(formValues: Partial<Incident>) {
    
    this.incidentService.updateIncident(this.incident().workItemId, formValues).subscribe(() => {
      this.router.navigate(['/']);
    });
  }


}
